import { render, staticRenderFns } from "./ImageBgBlock.vue?vue&type=template&id=25cb6a9c&"
import script from "./ImageBgBlock.vue?vue&type=script&lang=js&"
export * from "./ImageBgBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImageBgBlock.vue?vue&type=style&index=0&id=25cb6a9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports